import {
  createActions,
  ReplicantAsyncActionAPI,
  ReplicantSyncActionAPI,
} from '@play-co/replicant';
import { ReplicantFromState, State, stateSchema } from 'src/replicant/State';
import computedProperties from 'src/replicant/config/computedProperties';
import messages from 'src/replicant/config/messages';
import scheduledActions from 'src/replicant/config/scheduledActions';
import ab from 'src/replicant/ruleset/ab';
import asyncGetters from 'src/replicant/config/asyncGetters';
import { sharedStates } from 'src/replicant/sharedState';

type Replicant = ReplicantFromState<typeof config>;
export type SyncActionAPI = ReplicantSyncActionAPI<Replicant>;
export type AsyncActionAPI = ReplicantAsyncActionAPI<Replicant>;

const config = {
  computedProperties,
  messages,
  scheduledActions,
  ruleset: { abTests: ab.dynamicAB },
  asyncGetters,
  sharedStates,
};
const createSharedStateActions = createActions(stateSchema, config);

type SharedStatesActionAPIs = Parameters<
  typeof createSharedStateActions
>[0][string];

type SharedStatesActionAPI = Parameters<
  Extract<SharedStatesActionAPIs, { type: 'sync' }>['fn']
>[2];

export function getSharedStateActionsAPI<T>(api: T): SharedStatesActionAPI {
  return api as unknown as SharedStatesActionAPI;
}

type SharedStatesAsyncActionAPI = Parameters<
  Extract<SharedStatesActionAPIs, { type: 'async' }>['fn']
>[2];
export function getSharedStateAsyncActionsAPI<T>(
  api: T,
): SharedStatesAsyncActionAPI {
  return api as unknown as SharedStatesAsyncActionAPI;
}

type SharedStates = Parameters<
  Extract<SharedStatesActionAPIs, { type: 'sync' }>['fn']
>[0]['userSharedStates'];

export function getUserSharedState(state: State): SharedStates {
  return (state as any).userSharedStates;
}
